import { Spinner } from '@fluentui/react';
import { FC } from 'react';

interface IProps {
  label?: string;
  fullHeight?: boolean;
}

const DefaultSpinner: FC<IProps> = ({ label = '', fullHeight = false }) => (
  <Spinner styles={{ root: { padding: 20, height: fullHeight ? '100%' : undefined } }} label={label} ariaLive="assertive" labelPosition="right" />
);

export default DefaultSpinner;